// @flow

declare var Intl: Object;

// takes in a date and formates it into "1 Augustus 2018"
export default (date: string): Date => new Intl.DateTimeFormat('nl', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
}).format(date);
